/**
 * Vanilla version of jquery param().
 * Turns an object of parameters into a url parameter string.
 * Supports nested objects and arrays using bracket notation, just like jQuery
 * @param params url parameters as key value pairs.
 */

type ParamValue = string | number | boolean | null | undefined | object;

const param = (params: object): string => {
  if (params == null) return '';

  const pairs: [string, string][] = [];

  function buildParams(obj: ParamValue, prefix: string = '') {
    if (obj == null) {
      // Skip null and undefined values
      return;
    }

    if (Array.isArray(obj)) {
      // Handle arrays: key[] for each element
      obj.forEach((item) => {
        if (item != null) {
          if (typeof item === 'object' && !Array.isArray(item)) {
            // Nested object in array
            buildParams(item, `${prefix}[]`);
          } else {
            pairs.push([`${prefix}[]`, String(item)]);
          }
        }
      });
    } else if (typeof obj === 'object') {
      // Handle nested objects
      Object.entries(obj).forEach(([key, value]) => {
        const newKey = prefix ? `${prefix}[${key}]` : key;
        if (value != null) {
          if (typeof value === 'object') {
            buildParams(value, newKey);
          } else {
            pairs.push([newKey, String(value)]);
          }
        }
      });
    } else {
      // Primitive value at top level
      pairs.push([prefix, String(obj)]);
    }
  }

  buildParams(params);

  return new URLSearchParams(pairs).toString();
};

export default param;
